import { j as t } from "../../jsx-runtime-82a9ddf6.js";
import { cva as g, cn as n } from "../../lib/cn.js";
const d = g(
  "py-[2px] px-2 font-medium text-xs leading-4 rounded-md max-w-fit capitalize",
  {
    variants: {
      variant: {
        orange: "dark:bg-orange-900 bg-orange-50 text-orange-600",
        purple: "dark:bg-purple-900/30 bg-purple-50 text-purple-600",
        red: "dark:bg-red-900 bg-red-50 text-red-600",
        blue: "dark:bg-blue-900/30 bg-blue-50 text-blue-600",
        green: "dark:bg-green-900/30 bg-green-50 text-green-600"
      }
    },
    defaultVariants: {
      variant: "purple"
    }
  }
), i = ({ variant: e, text: r, className: a }) => /* @__PURE__ */ t.jsx("div", { className: n(a, d({ variant: e })), children: r });
export {
  i as Badge
};
